import { useLeadsSheetStore } from "../../../../../../../../stores/LeadsStore";
import { ActionIcon, Button, Menu, Tooltip } from "@mantine/core";
import {
  IconBrandLinkedin,
  IconChevronDown,
  IconPlus,
} from "@tabler/icons-react";
import LinkedinSenderModal from "../linkedin/LinkedinSenderModal";
import { useLanguage } from "../../../../../../../../stores/LanguageStore";

const ConversationStart = ({ isIcon, disabled }) => {
  const lang = useLanguage((s) => s.language);
  const current = useLeadsSheetStore((s) => s.current);
  const setLoading = useLeadsSheetStore((s) => s.setLoading);

  const handleMessageSent = () => {
    setLoading(true);
  };

  return (
    <Menu keepMounted zIndex={300}>
      <Menu.Target>
        {isIcon ? (
          <Tooltip label={lang.leads.start_linkedin_conversation}>
            <ActionIcon variant="subtle" size={"md"} disabled={disabled}>
              <IconPlus size={16} />
            </ActionIcon>
          </Tooltip>
        ) : (
          <Button
            leftSection={<IconBrandLinkedin size={18} />}
            rightSection={<IconChevronDown size={18} />}
            size="md"
            mr={8}
            disabled={disabled}
          >
            {lang.leads.start_linkedin_conversation}
          </Button>
        )}
      </Menu.Target>

      <Menu.Dropdown>
        <Menu.Item>
          <LinkedinSenderModal
            current={current}
            onSent={handleMessageSent}
            isInvitation
          />
        </Menu.Item>

        <Menu.Divider opacity={0.5} my={6} />

        <Menu.Item>
          <LinkedinSenderModal current={current} onSent={handleMessageSent} />
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};

export default ConversationStart;
